import { ConfigProvider } from "antd";
import { logout, updateProfile } from "modules/auth/authSlice";
import { useDispatch } from "react-redux";
// import { useLazyLogoutQuery } from "services/authServiceWithToken";
import { useAuth } from "shared/hooks";
import ManageRoutes from "./routes";
import "./views/styles/index.scss";
import useIdleTimeout from "shared/hooks/useIdleTimeout";
import { useEffect } from "react";

interface IdleTimeoutOptions {
  onIdle: () => void;
  idleTime?: number;
}

function App() {
  // const [getLogoutUser] = useLazyLogoutQuery();
  const dispatch = useDispatch();
  const { email } = useAuth();

  const handleLogout = async () => {
    if (email) {
      dispatch(logout());
      dispatch(
        updateProfile({
          "2fa_setuped_at": "",
          authenticator_type: "",
          created_at: "",
          email: "",
          email_verified_at: "",
          external_user_id: "",
          id: "",
          last_name: "",
          name: "",
          password_changed_at: "",
          permissions: [],
          phone_number: "",
          roles: "",
          status: 0,
          updated_at: "",
          use_new_payout_report: false,
          user_type: "",
        })
      );
      if (process.env.REACT_APP_SUB_PATH) {
        window.location.href = `${process.env.REACT_APP_SUB_PATH}`;
      } else {
        window.location.href = `/`;
      }
    }
  };

  const { isIdle, setIdle, idleTimer } = useIdleTimeout({
    idleTime: 15 * 60, // Optional: Customize the idle time in seconds (default is 900 seconds or 15 minutes)
    onTimeout: handleLogout,
  });

  // Logout the user when idle

  return (
    <>
      <ConfigProvider>
        <ManageRoutes />
      </ConfigProvider>
    </>
  );
}

export default App;
